module.exports = __webpack_public_path__ + "static/img/disneyland_c.d1c44e6b.png";